import React, { useContext, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import AuthLayout from "../../../components/molecules/AuthLayout";
import CustomInput from "../../../components/atoms/Inputs/CustomInput";
import PrimaryButton from "../../../components/atoms/PrimaryButton";
import GlobalContext from "../../../context/GlobalContext";
import axios from "../../../utils/axiosconfig";
import { showSuccess, showWaring } from "../../../utils";
import qs from "qs";

const ResetPassword = (props) => {
  const site_id = localStorage.getItem("site_id");
  const history = useHistory();
  const location = useLocation();
  const { loading } = useContext(GlobalContext);
  const store_id = window.location.pathname.split("/")[1];
  const passwordSchema = Yup.object({
    password: Yup.string()
      .min(8, "Minimum 8 characters")
      .required("Password is required"),
    confirmpassword: Yup.string()
      .min(8, "Minimum 8 characters")
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  useEffect(() => {
    if (location.search) {
      let query = qs.parse(location.search, { ignoreQueryPrefix: true });
      if (!query.fpid) {
        history.push("/");
      }
    }
  }, []);

  const handleLogin = async (formBody) => {
    loading.set(true);
    let query = qs.parse(location.search, { ignoreQueryPrefix: true });
    let { data } = await axios.post(
      "forgetPasswordSave",
      {
        new_password: formBody.password,
        id: query.fpid,
      },
      {
        headers: {
          site_id,
        },
      },
    );
    loading.set(false);
    if (data.success === true) {
      showSuccess(data.reason);
      setTimeout(() => {
        history.push(`/login`);
      }, 3000);
    } else {
      showWaring("Something went wrong");
    }
  };

  return (
    <AuthLayout title="Reset Update">
      <Formik
        initialValues={{ password: "", confirmpassword: "" }}
        validationSchema={passwordSchema}
        onSubmit={(values) => handleLogin(values)}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form
            className="form py-2 m-0"
            onSubmit={handleSubmit}
            noValidate
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div className="form-group">
              <CustomInput
                label="Password"
                value={values.email}
                name="password"
                type="password"
                onChange={handleChange}
                onBlur={handleBlur}
                className={`hh-input ${
                  errors.password && touched.password && "is-invalid"
                }`}
                placeholder="Enter Password"
                required
                shrink={true}
              />
              {errors.password && touched.password ? (
                <div className="invalid-feedback">{errors.password}</div>
              ) : null}
            </div>
            <div className="form-group">
              <CustomInput
                label="Confirm Password"
                value={values.confirmpassword}
                name="confirmpassword"
                type="password"
                onChange={handleChange}
                onBlur={handleBlur}
                className={`hh-input ${
                  errors.confirmpassword &&
                  touched.confirmpassword &&
                  "is-invalid"
                }`}
                placeholder="Enter Confirm Password"
                required
              />
              {errors.confirmpassword && touched.confirmpassword ? (
                <div className="invalid-feedback">{errors.confirmpassword}</div>
              ) : null}
            </div>
            <PrimaryButton
              label="Reset Password"
              type="submit"
              disabled={loading.get}
            />
          </form>
        )}
      </Formik>
    </AuthLayout>
  );
};

export default ResetPassword;
